import { useEffect } from "react";
import {
  EfsMelcoModelsDesign,
  EfsMelcoModelsDesignElement,
  EfsMelcoEfsModelsMappingOutputElement,
} from "melco-shared-logic";
import { useField } from "formik";
import {
  DesignElementToDataMappingType,
  DesignElementType,
} from "../../components/inputFormats/SelectDataMappingType";

const toOutputElement = (designElement: EfsMelcoModelsDesignElement) => {
  const { id, type, lettering_id } = designElement;

  return {
    name: id,
    type: type
      ? DesignElementToDataMappingType[type as DesignElementType]
      : undefined,
    lettering_id,
    mapping_id: "",
    attributes: [],
  } as EfsMelcoEfsModelsMappingOutputElement;
};

export const designTypeToOutputTypeMapping = {
  Lettering: "Lettering",
  Color: "Color",
  Design: "Display",
} as const;

export const useOutputElements = (
  design: EfsMelcoModelsDesign,
  mappableElements: EfsMelcoModelsDesignElement[]
) => {
  const [{ value: outputElementsValue }, , { setValue: setOutputElements }] =
    useField<EfsMelcoEfsModelsMappingOutputElement[]>("outputs[0].elements");

  const outputElements = outputElementsValue ?? [];

  useEffect(() => {
    const newOutputElements: EfsMelcoEfsModelsMappingOutputElement[] =
      mappableElements.map((element) => {
        const outputElement = toOutputElement(element);

        const oldOutputElement = outputElements.find(
          (oe) => oe.name === outputElement.name
        );

        if (oldOutputElement) {
          outputElement.mapping_id = oldOutputElement.mapping_id;
          outputElement.lettering_id = oldOutputElement.lettering_id;
          outputElement.is_delete_empty = oldOutputElement.is_delete_empty;
        }

        return outputElement;
      });

    setOutputElements(newOutputElements);
  }, [design.id]); // only overwrite output elements when design has changed
};
